import { TPosition } from "./types";

export const POSITION: TPosition[] = [
  { id: 'tour_leader', label: 'b2b.txt.tour_leader' },
  { id: 'licensed_tour_guide', label: 'b2b.txt.licensed_tour_guide' },
]